import { makeHook } from "../../utils/makeSingleArgHook";
import getConsumedBudget, { url, } from "../requests/getConsumedBudget";
export function consumedBudgetKeyMaker(params) {
    const { clientId, ...queryParams } = params;
    return [url(clientId), JSON.stringify(queryParams)];
}
const useGetConsumedBudget = makeHook(getConsumedBudget, (params) => consumedBudgetKeyMaker(params));
export default useGetConsumedBudget;
//# sourceMappingURL=useGetConsumedBudget.js.map